import React from 'react';
import { Info } from 'lucide-react';

/**
 * Soft recommendation shown to clients before contacting a company or registering.
 * Kept as a shared component so the message can be updated in one place.
 */
const AntiScamWarning = ({ className = '', testId = 'anti-scam-warning' }) => {
  return (
    <div
      className={`flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700 leading-snug ${className}`}
      data-testid={testId}
    >
      <Info className="h-4 w-4 shrink-0 mt-0.5 text-slate-500" />
      <span>
        Per una maggiore sicurezza, consigliamo il pagamento alla consegna del mezzo.
      </span>
    </div>
  );
};

export default AntiScamWarning;

